import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import {VehicleMakerEnum, type Vehicle} from '../domain/vehicle';


const initialState: Vehicle = {
    color: '',
    licensePlate: '',
    maker: 'alfa_romeo' as VehicleMakerEnum,
    model: '',
    vehicleType: undefined,
    year: new Date().getFullYear(),
};

const pendingVehicleSlice = createSlice({
    initialState,
    name: 'temp-vehicle',
    reducers: {
        clearPendingVehicle: () => 
            initialState // Replace the state with the new vehicle
        ,
        setPendingVehicle: (state, action: PayloadAction<Vehicle>) => 
            action.payload // Replace the state with the new vehicle
        ,
      
        updatePendingVehicleProps: (state, action: PayloadAction<Vehicle>) => 
            ({ ...state, ...action.payload }) // Clear the state 
        ,
    },
});

export const { setPendingVehicle, clearPendingVehicle, updatePendingVehicleProps } = pendingVehicleSlice.actions;
export default pendingVehicleSlice.reducer;